<template>
  <div
    class="relative mr-2 size-[180px] shrink-0 overflow-hidden bg-white-smoke"
    :style="{ width: widthSize, height: heightSize }"
  >
    <SFLocalizedLink
      v-if="link"
      :to="link"
      raw
      class="block size-full rounded-md focus:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-black"
    >
      <SFProductImage
        v-if="image"
        :alt="alt"
        :quality="75"
        :image="image"
        loading="lazy"
        sizes="xs:180px sm:180px md:338px lg:338px xl:338px"
        :class="[{ 'opacity-60': isSoldOut }]"
        class="overflow-hidden"
      />
      <SFPromotionBadge
        v-if="basketItem.promotion"
        :style="style"
        :text="text"
        class="absolute bottom-2.5 ml-1"
      />
    </SFLocalizedLink>

    <div
      v-if="!hideWishlistToggle"
      class="absolute left-auto right-1 top-2 z-10 flex h-8 w-auto cursor-pointer p-1 transition lg:right-0 lg:top-0 lg:h-12 lg:p-3"
    >
      <SFWishlistToggle :product="basketItem.product" @click.stop />
    </div>
  </div>
</template>
<script lang="ts" setup>
import { computed } from 'vue'
import type { BasketItem } from '@scayle/storefront-nuxt'
import SFPromotionBadge from '../promotion/SFPromotionBadge.vue'
import SFLocalizedLink from '~/components/SFLocalizedLink.vue'
import SFProductImage from '~/components/product/SFProductImage.vue'
import SFWishlistToggle from '~/components/product/SFWishlistToggle.vue'
import { useProductBaseInfo } from '~/composables'
import { getPromotionStyle } from '~/utils'

const {
  basketItem,
  isSoldOut,
  hideWishlistToggle = false,
  width,
  height,
} = defineProps<{
  basketItem: BasketItem
  isSoldOut: boolean
  hideWishlistToggle?: boolean
  height?: number | string
  width?: number | string
}>()

const { image, alt, link } = useProductBaseInfo(basketItem.product)

const text = computed(() => {
  return basketItem.promotion?.customData.product?.badgeLabel
})

const style = computed(() => {
  const promotion = basketItem.promotion
  return getPromotionStyle(promotion)
})

const widthSize = computed(() => {
  if (typeof width === 'string' && width.includes('px')) {
    return width
  }
  return `${width}px`
})
const heightSize = computed(() => {
  if (typeof height === 'string' && height.includes('px')) {
    return height
  }
  return `${height}px`
})
</script>
